export default "__VITE_ASSET__0qxVfa46__"